import { render, staticRenderFns } from "./ProjectEditModal.vue?vue&type=template&id=47024515&scoped=true&"
import script from "./ProjectEditModal.vue?vue&type=script&lang=ts&"
export * from "./ProjectEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectEditModal.vue?vue&type=style&index=0&id=47024515&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47024515",
  null
  
)

export default component.exports